import axios from 'axios'
import router from '../../router'

/**
 * initial state
 */
const state = () => ({
  // todo
})

/**
 * getters
 */
const getters = {
  // todo
}

/**
 * mutations
 */
const mutations = {
  // todo
}

/**
 * actions
 */
const actions = {
  /**
   * List Quotation
   */
  /**
   * List Quotation
   */
  listQuotation(context, credentials) {
    return new Promise((resolve, reject) => {
      console.log('API list quotation params ::', credentials)
      axios
        .post(process.env.VUE_APP_PA_TAMJAI_LIST_VIEW, credentials)
        .then((response) => resolve(response))
        .catch((error) => reject(error))
    })
  },

  /**
   * View Quotation Detail
   * @param paTamjaiId
   * @return {array}
   */
  viewQuotationDetail(context, credentials) {
    return new Promise((resolve, reject) => {
      axios
        .get(process.env.VUE_APP_CANCER_PROMPT_VIEW + '/' + credentials.quotationId)
        .then((response) => {
          console.log('API view quotation detail ::', response)
          if (response.status == 200) {
            if (response.data.isSuccess) {
              if (response.data.data.id == null) {
                resolve('No content')
                console.error('No content')
                router.push({ name: 'history' })
              }
              // isSuccess
              resolve(response.data.data)
            } else {
              // !isSuccess
              reject(response.data.message)
            }
          } else reject(response.data)
        })
        .catch((error) => {
          console.log(error)
          reject(error)
        })
    })
  },

  /**
   * View Quotation Detail
   * @param paTamjaiId
   * @return {array}
   */
  viewTamjaiQuotationDetail(context, credentials) {
    return new Promise((resolve, reject) => {
      axios
        .get(process.env.VUE_APP_CANCER_TAMJAI_VIEW + '/' + credentials.quotationId)
        .then((response) => {
          console.log('API view quotation detail ::', response)
          if (response.status == 200) {
            if (response.data.isSuccess) {
              if (response.data.data.id == null) {
                resolve('No content')
                console.error('No content')
                router.push({ name: 'history' })
              }
              // isSuccess
              resolve(response.data.data)
            } else {
              // !isSuccess
              reject(response.data.message)
            }
          } else reject(response.data)
        })
        .catch((error) => {
          console.log(error)
          reject(error)
        })
    })
  },

  /**
   * Approve quotation function
   */
  approveQuotation(context, credential) {
    return new Promise((resolve, reject) => {
      axios
        .post(process.env.VUE_APP_PA_TAMJAI_APPROVE, {
          smeFireinsuranceId: credential.quotationId,
        })
        .then((result) => {
          resolve(result)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },

  reportCia(context, credential) {
    return new Promise((resolve, reject) => {
      // console.log('report cia params ::', credential)
      const params = {
        startDate: credential.startDate,
        endDate: credential.endDate,
        referral_type: credential.referral_type,
      }
      console.log('report cia params ::', params)
      axios
        .post(process.env.VUE_APP_REPORT_CIA_CANCER, params, {
          responseType: 'blob',
        })
        .then((res) => resolve(res))
        .catch((err) => reject(err))
    })
  },
  reportCiaStatus2(context, credential) {
    return new Promise((resolve, reject) => {
      // console.log('report cia params ::', credential)
      const params = {
        startDate: credential.startDate,
        endDate: credential.endDate,
        referral_type: credential.referral_type,
      }
      axios
        .post(process.env.VUE_APP_REPORT_CIA_STATUS_2_CANCER, params, {
          responseType: 'blob',
        })
        .then((res) => resolve(res))
        .catch((err) => reject(err))
    })
  },
  reportExcel(context, credential) {
    return new Promise((resolve, reject) => {
      // console.log('report cia params ::', credential)
      const params = {
        startDate: credential.startDate,
        endDate: credential.endDate,
      }
      console.log('report excel params ::', params)
      axios
        .post(process.env.VUE_APP_REPORT_EXCEL_CANCER, params, {
          responseType: 'blob',
        })
        .then((res) => resolve(res))
        .catch((err) => reject(err))
    })
  },

  reportRawData(context, credential) {
    return new Promise((resolve, reject) => {
      console.log('report raw data params ::', credential)
      const params = {
        startDate: credential.startDate,
        endDate: credential.endDate,
      }

      axios
        .get(process.env.VUE_APP_REPORT_RAW + '?startDate=' + params.startDate + '&endDate=' + params.endDate, {
          responseType: 'blob',
        })
        .then((res) => resolve(res))
        .catch((err) => reject(err))
    })
  },

  checkPaymentStatus() {
    return new Promise((resolve, reject) => {
      axios
        .get(process.env.VUE_APP_PA_TAMJAI_CHECK_PAYMENT)
        .then((res) => resolve(res))
        .catch((err) => reject(err))
    })
  },

  getRejectList() {
    return new Promise((resolve, reject) => {
      axios
        .get(process.env.VUE_APP_PA_TAMJAI_REJECT_LIST)
        .then((res) => resolve(res))
        .catch((err) => reject(err))
    })
  },

  rejectQuotation(context, credential) {
    return new Promise((resolve, reject) => {
      console.log('API reject quotation ::', context, credential)
      axios
        .post(process.env.VUE_APP_PA_TAMJAI_REJECT, credential)
        .then((res) => resolve(res))
        .catch((err) => reject(err))
    })
  },
  updatedPayment(context, credential) {
    return new Promise((resolve, reject) => {
      const param = credential
      console.log('API update payment ::', param)
      axios
        .post(process.env.VUE_APP_UPLOAD_PAYMENT_CANCER, param)
        .then((res) => resolve(res))
        .catch((err) => reject(err))
    })
  },
  updatedPaymentTamjai(context, credential) {
    return new Promise((resolve, reject) => {
      const param = credential
      console.log('API update payment Cancer Tamjai ::', param)
      axios
        .post(process.env.VUE_APP_UPLOAD_PAYMENT_CANCER_TAMJAI, param)
        .then((res) => resolve(res))
        .catch((err) => reject(err))
    })
  },

  updatedPaymentDateTamjai(context, credential) {
    return new Promise((resolve, reject) => {
      const param = {
        type: credential.type,
        amount: credential.amount,
        payment_type: credential.payment_type,
        payment_date: credential.payment_date,
      }
      console.log('API update payment Cancer Tamjai ::', param)
      axios
        .post(process.env.VUE_APP_UPDATE_PAYMENT_DATE_CANCER_TAMJAI + '/' + credential.id, param)
        .then((res) => resolve(res))
        .catch((err) => reject(err))
    })
  },

  updatedPaymentDatePrompt(context, credential) {
    return new Promise((resolve, reject) => {
      const param = {
        type: credential.type,
        amount: credential.amount,
        payment_type: credential.payment_type,
        payment_date: credential.payment_date,
      }
      console.log('API update payment Cancer Prompt ::', param)
      axios
        .post(process.env.VUE_APP_UPDATE_PAYMENT_DATE_CANCER_PROMPT + '/' + credential.id, param)
        .then((res) => resolve(res))
        .catch((err) => reject(err))
    })
  },

  cancelPaymentPrompt(context, credential) {
    return new Promise((resolve, reject) => {
      const param = {
        id: credential.id,
      }
      console.log('API update payment Cancer Prompt ::', param)
      axios
        .post(process.env.VUE_APP_CANCEL_PAYMENT_CANCER_PROMPT + '/' + param.id)
        .then((res) => resolve(res))
        .catch((err) => reject(err))
    })
  },

  cancelPaymentTamjai(context, credential) {
    return new Promise((resolve, reject) => {
      const param = {
        id: credential.id,
      }
      console.log('API update payment Cancer Tamjai ::', param)
      axios
        .post(process.env.VUE_APP_CANCEL_PAYMENT_CANCER_TAMJAI + '/' + param.id)
        .then((res) => resolve(res))
        .catch((err) => reject(err))
    })
  },
  updateImageStaffTamjai(context, credential) {
    return new Promise((resolve, reject) => {
      const param = {
        quatation_number: credential.quatation_number,
        staff_image: [
          {
            file_name: credential.file_name,
            image_base64: credential.image_base64,
          },
        ],
      }
      console.log('API update image staff Tamjai ::', param)
      axios
        .post(process.env.VUE_APP_CANCER_UPDATE_STAFF_IMAGE, param)
        .then((res) => resolve(res))
        .catch((err) => reject(err))
    })
  },

  approveImageStaffTamjai(context, credential) {
    return new Promise((resolve, reject) => {
      axios
        .get(process.env.VUE_APP_APPROVE_STAFF_IMAGE + '/' + credential.id)
        .then((res) => resolve(res))
        .catch((err) => reject(err))
    })
  },
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
}
